(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-swatches"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-seven-show-swatches]');
    if (!button) return;

    const list = button.closest('.seven-swatch-list');
    if (!list) return;

    list.classList.add('is-expanded');
    button.setAttribute('aria-expanded', 'true');
    button.closest('.seven-swatch-list__more').hidden = true;
  });
  } catch(e) { console.error(e); }
})();

})();
